export const useGetToolbarMainActions = ({ availableActions, excludedActions }: { availableActions: any[], excludedActions: any[] }) => {
  return availableActions.filter(action => !excludedActions.includes(action.id))
}
